import React, { useState, createContext, useContext } from 'react';
import { translations, Language } from '../data/translations';
interface LanguageContextType {
  language: Language;
  toggleLanguage: () => void;
  t: (key: keyof (typeof translations)['bn']) => string;
}
const LanguageContext = createContext<LanguageContextType | undefined>(undefined);
export function LanguageProvider({
  children
}: {
  children: ReactNode;
}) {
  const [language, setLanguage] = useState<Language>('bn');
  const toggleLanguage = () => {
    setLanguage(prev => prev === 'bn' ? 'en' : 'bn');
  };
  const t = (key: keyof (typeof translations)['bn']): string => {
    return translations[language][key] || key;
  };
  return <LanguageContext.Provider value={{
    language,
    toggleLanguage,
    t
  }} data-id="element-65">
      {children}
    </LanguageContext.Provider>;
}
export function useLanguage() {
  const context = useContext(LanguageContext);
  if (context === undefined) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
}